import fetch from "@elements/fetch";
import initModulesInScope from "@elements/init-modules-in-scope";

export function init() {
    let $summery = $('.js-cart-detail__summery');

    $(document.body).on('country-changed', function (evt, country) {

        fetch(`/${_config.lang}/checkout/cart/summary/${country || _config.lang}`).then(response => response.json()).then((data) => {
            if (data.success) {
                $summery.html(data.content);
                initModulesInScope($summery);
            }
        })
    });
}